import * as React from 'react'
import styled from 'styled-components'
import { Button } from '../atoms/Button'
import { Content } from '../atoms/Content/index'
import { Input } from '../atoms/Input'
import { Layout } from '../atoms/Layout'
import { Link } from '../atoms/Link'
import { Nav } from '../atoms/Nav'
import { P } from '../atoms/P'
import { media } from '../utils/media'
import { ForgotPasswordContainer} from '../organisms/ForgotPasswordForm/ForgotPasswordContainer'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

const translations = {
  'en': {
    forgotPassword: 'Forgot your Password?',
    enterPassword: 'Enter your email and we\'ll send you a link to reset your password!',
  },
  'es': {
    forgotPassword: '¿Olvidaste tu contraseña?',
    enterPassword: 'Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
  },
}

export const ForgotPasswordPage = () => (
  <Layout>
    <Nav.Bar>
      <Nav.HomeButtonWeb />
    </Nav.Bar>
    <Content style={{ textAlign: 'center' }}>
      <H1>{translations[lang].forgotPassword}</H1>
      <P>{translations[lang].enterPassword}</P>
      <ForgotPasswordContainer />
    </Content>
  </Layout>
)

const H1 = styled.h1`
  margin-top: 90px;
  font-family: Nunito;
  font-size: 24px;
  font-weight: 900;
  color: #12385b;

  ${media.tablet`
    font-size: 54px;
  `}
`



// WEBPACK FOOTER //
// ./src/pages/ForgotPasswordPage.tsx